import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, ClipboardList, FolderOpen, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../api';

export const RecertVisitActions = ({ appointment, onChanged }) => {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const done = appointment.status === 'Completed';
  const hasForm = Boolean(appointment.formId);
  const formUrl = `/dashboard/forms/recertification?appointmentId=${appointment.id}${hasForm ? `&id=${appointment.formId}` : ''}`;

  const markDone = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/recert/visit/${appointment.id}/complete`);
      toast.success(r.data.message);
      onChanged();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not mark the visit done');
    } finally {
      setBusy(false);
    }
  };

  const btn = 'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-colors';
  return (
    <div className="flex flex-wrap gap-2 mt-3" data-testid={`recert-visit-actions-${appointment.id}`}>
      {appointment.reviewNote && !done && (
        <p className="w-full text-sm bg-amber-50 border border-amber-300 text-amber-800 rounded-lg px-3 py-2" data-testid={`review-note-${appointment.id}`}>
          <strong>Office requested changes:</strong> {appointment.reviewNote}
        </p>
      )}
      <button onClick={() => navigate(`/dashboard/patients/demographics/${appointment.patientId}`)} data-testid={`open-chart-${appointment.id}`}
        className={`${btn} border border-gray-300 text-gray-700 hover:bg-gray-50`}>
        <FolderOpen className="w-4 h-4" /> Open Chart
      </button>
      <button onClick={() => navigate(formUrl)} data-testid={`start-recert-${appointment.id}`}
        className={`${btn} bg-gray-900 text-[#d4af37] hover:bg-gray-800`}>
        <ClipboardList className="w-4 h-4" /> {hasForm ? 'Open Recert Assessment' : 'Start Recert Assessment'}
      </button>
      {done ? (
        <span className={`${btn} bg-green-100 text-green-800`} data-testid={`visit-done-${appointment.id}`}><CheckCircle2 className="w-4 h-4" /> Done</span>
      ) : (
        <button onClick={markDone} disabled={!hasForm || busy} data-testid={`mark-done-${appointment.id}`}
          title={hasForm ? 'Mark this recert visit complete' : 'Save the Recertification Assessment first'}
          className={`${btn} bg-green-600 text-white hover:bg-green-700 disabled:opacity-40 disabled:cursor-not-allowed`}>
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCircle2 className="w-4 h-4" />} Mark Visit Done
        </button>
      )}
      {!hasForm && !done && <span className="text-xs text-gray-500 self-center" data-testid={`mark-done-hint-${appointment.id}`}>Save the recert form to enable Mark Visit Done</span>}
    </div>
  );
};
